<script setup lang="ts">
import { withDefaults } from 'vue'
import CircleShape from '../shapes/CircleShape.vue'

interface PropTypes {
  color?: string
  status?: string
}

withDefaults(defineProps<PropTypes>(), {
  color: 'black',
  status: null,
})
</script>

<template>
  <div class="h-100 w-100 flex items-center justify-start">
    <CircleShape :color="color" :size="3" />
    <div class="ml-2">
      <slot>{{ status ? status : null }}</slot>
    </div>
  </div>
</template>
